let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1oiJ6")).then(() => parcelRequire('d5BUD'));